import * as Joi from 'joi';

const schemaLoginForm = Joi.object({
  username: Joi.string().required().messages({
    'string.empty': 'Username is not allowed to be empty.',
    'any.required': 'Username is not allowed to be empty.',
  }),
  password: Joi.string().min(12).required().messages({
    'string.empty': 'Password is not allowed to be empty.',
    'any.required': 'Password is not allowed to be empty.',
  }),
}).with('username', 'password');

export default schemaLoginForm;
